import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet';
import Layout from '../components/Layout'



const BlogPost = (props) => {
  const { siteMetadata } = props.data.site
  const { frontmatter, html } = props.data.markdownRemark;
  return (
    <Layout>
      <Helmet>
        <title>{frontmatter.title} | {siteMetadata.title}</title>
        <meta name="description" content={frontmatter.description} />
      </Helmet>
      <article className="post">
        <h1 className="post-title">{frontmatter.title}</h1>
        <p className="post-meta"> {frontmatter.date}</p>
        <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: html }}></div>
      </article>
    </Layout>
  )
}
export const query = graphql`
  query($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        date(formatString: "DD.MM.YYYY")

      }
      html
    }
  }
`
export default BlogPost
